import { get } from 'jquery';
import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/CompanyDetails.api';

export const CreateCompanyDetailsRequest = (CompanyDetailsInput) => ({
  type: actionTypes.CREATE_COMPANY_DETAILS_REQUEST,
  payload: CompanyDetailsInput,
});

export const CreateCompanyDetailsSuccess = (user) => ({
  type: actionTypes.CREATE_COMPANY_DETAILS_SUCCESS,
  payload: user,
});

export const CreateCompanyDetailsFailure = (error) => ({
  type: actionTypes.CREATE_COMPANY_DETAILS_FAILURE,
  payload: error,
});


export const companyDetailsDataInput = (CompanyDetailsInput) => {
  return async (dispatch) => {
    dispatch(CreateCompanyDetailsRequest(CompanyDetailsInput));
    try {
      const response = await api.companyDetailsDataInput(CompanyDetailsInput);
      if (response.status == 201 ||response.status === 200 ) {
        dispatch(CreateCompanyDetailsSuccess(response.data.message));
        return { success: true };
      } else {
        dispatch(CreateCompanyDetailsFailure(response.message || 'CompanyDetails input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(CreateCompanyDetailsFailure(error || 'An error occurred'));
      return { success: false, message: error };
    }
  };
};


export const getCompanyDetailsRequest = () => ({
  type: actionTypes.GET_COMPANY_DETAILS_REQUEST,
});

export const getCompanyDetailsSuccess = (company_data) => ({
  type: actionTypes.GET_COMPANY_DETAILS_SUCCESS,
  payload: company_data,
});

export const getCompanyDetailsFailure = (error) => ({
  type: actionTypes.GET_COMPANY_DETAILS_FAILURE,
  payload: error,
});

export const getCompanyDetails = (id) => {
  return async (dispatch) => {
    dispatch(getCompanyDetailsRequest());
    try {
      const company_data = await api.fetchCompanyDetails(id);
      dispatch(getCompanyDetailsSuccess(company_data));
      return { success: true, data: company_data };
    } catch (error) {
      dispatch(getCompanyDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getAllCompanyDetailsRequest = () => ({
  type: actionTypes.GET_COMPANY_DETAILS_REQUEST,
});

export const getAllCompanyDetailsSuccess = (company_data) => ({
  type: actionTypes.GET_COMPANY_DETAILS_SUCCESS,
  payload: company_data,
});

export const getAllCompanyDetailsFailure = (error) => ({
  type: actionTypes.GET_COMPANY_DETAILS_FAILURE,
  payload: error,
});

export const getAllCompanyDetails = () => {
  return async (dispatch) => {
    dispatch(getAllCompanyDetailsRequest());
    try {
      const company_data = await api.fetchAllCompanyDetails();
      dispatch(getAllCompanyDetailsSuccess(company_data));
      return { success: true, data: company_data };
    } catch (error) {
      dispatch(getAllCompanyDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const updateCompanyDetailsRequest = (id, companyData) => ({
  type: actionTypes.UPDATE_COMPANY_DETAILS_REQUEST,
  payload: { id, companyData },
});

export const updateompanyDetailsSuccess = (message) => ({
  type: actionTypes.UPDATE_COMPANY_DETAILS_SUCCESS,
  payload: message,
});

export const updateCompanyDetailsFailure = (error) => ({
  type: actionTypes.UPDATE_COMPANY_DETAILS_FAILURE,
  payload: error,
});

export const updateCompanyDetailsById = (id, companyData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    companyData.updated_by = user.user_name;

    dispatch(updateCompanyDetailsRequest(id, companyData));
    try {
      const response = await api.updateCompanyDetails(id, companyData);
      dispatch(updateompanyDetailsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateCompanyDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};
export const deleteCompanyDetailsRequest = (id) => ({
  type: actionTypes.DELETE_COMPANY_DETAILS_REQUEST,
  payload: id,
});

export const deleteCompanyDetailsSuccess = (message) => ({
  type: actionTypes.DELETE_COMPANY_DETAILS_SUCCESS,
  payload: message,
});

export const deleteCompanyDetailsFailure = (error) => ({
  type: actionTypes.DELETE_COMPANY_DETAILS_FAILURE,
  payload: error,
});

export const deleteCompanyDetailsById = (id) => {
  return async (dispatch) => {
    dispatch(deleteCompanyDetailsRequest(id));
    try {
      const response = await api.deleteCompanyDetails(id);
      dispatch(deleteCompanyDetailsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteCompanyDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


